module.exports = __webpack_public_path__ + "static/media/Bytt-tutorial-3.378840e0.mp3";